import { connect }  from 'react-redux';
import LaunchAs     from './launch-as.jsx';
import { launchAs } from '../login/login-dux';

export default connect(
    // mapStateToProps
    state => {
        return {
            busyLaunchAs: state.loginData.busyLaunchAs,
        };
    },
    // mapDispatchToProps
    {
        launchAs,
    }
)( LaunchAs );
